// extracted by mini-css-extract-plugin
export default {"footerLeftItemContainer":"FooterLeftItemContainer_footerLeftItemContainer__fO-FS"};